import React from "react";
import Layout from "../../Layout";
import HeaderBread from "../../components/HeaderBread";
import MenubarInput from "../../components/Menubar/MenubarInput";

const CreateMenubar = () => {
  const navigation = [
    { title: "Home", route: "/" },
    { title: "Menubar", route: "/website/cms/homepage/menubar" },
    { title: "Add Menu", route: "/website/cms/homepage/menubar/add" },
  ];

  return (
    <Layout type={"create_per"} module_data={"Menubar"}>
      <HeaderBread navigation={navigation} title={"Add Menu"}></HeaderBread>
      <MenubarInput menubar={{}} />
    </Layout>
  );
};

export default CreateMenubar;
